module.exports = __webpack_public_path__ + "img/2.03.95807057.jpg";